import { render, staticRenderFns } from "./FrequentlyAskedQuestionBox.vue?vue&type=template&id=dbf77520&"
import script from "./FrequentlyAskedQuestionBox.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAskedQuestionBox.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAskedQuestionBox.vue?vue&type=style&index=0&id=dbf77520&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports